var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('v-select',{staticClass:"bg-white",attrs:{"options":_vm.optgroups,"clearable":false},model:{value:(_vm.projectValue),callback:function ($$v) {_vm.projectValue=$$v},expression:"projectValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }